export const getEnumByID = (id, enums) => {
  for (const propName in enums) {
    if ({}.hasOwnProperty.call(enums, propName)) {
      const enumeration = enums[propName];
      if (
        enumeration.hasOwnProperty('id') &&
        String(enumeration.id) === String(id)
      ) {
        return enumeration;
      }
    }
  }
};

export const getEnumBySlug = (slug, enums) => {
  for (const propName in enums) {
    if ({}.hasOwnProperty.call(enums, propName)) {
      const enumeration = enums[propName];
      if (enumeration.hasOwnProperty('slug') && enumeration.slug === slug) {
        return enumeration;
      }
    }
  }
  if (enums.getDefault && typeof enums.getDefault === 'function') {
    return enums.getDefault(slug);
  }
};

export const getEnumByIDOrDefault = (id, enums) => {
  return getEnumByID(id, enums) || enums.DEFAULT;
};

export const getEnumBySlugOrDefault = (id, enums) => {
  return getEnumBySlug(id, enums) || enums.DEFAULT;
};

export const getEnumDictById = (Enum) => {
  const dict = {};
  for (const key of Object.keys(Enum)) {
    const type = Enum[key];
    dict[type.id] = type;
  }
  return dict;
};

export const getEnumDictBySlug = (Enum) => {
  const dict = {};
  for (const key of Object.keys(Enum)) {
    const type = Enum[key];
    dict[type.slug] = type;
  }
  return dict;
};
